import { EMAIL_PATTERN, NAME_WITH_NUMBER_PATTERN, RAW_PHONE_NUMBER_PATTERN } from 'constants/common'
import { IApplicationFormValues } from 'interfaces/application'

export function validatePaystubStep(formValue: IApplicationFormValues): boolean {
  if (formValue?.previousLandlordPhoneNumber && formValue?.previousLandlordName) {
    const isValidPhoneNumber: boolean = RAW_PHONE_NUMBER_PATTERN.test(formValue.previousLandlordPhoneNumber)
    const isValidName: boolean = NAME_WITH_NUMBER_PATTERN.test(formValue.previousLandlordName)
    const isValidEmail: boolean = formValue?.previousLandlordEmail
      ? EMAIL_PATTERN.test(formValue.previousLandlordEmail)
      : true
    return isValidPhoneNumber && isValidName && isValidEmail
  }
  return false
}
